<template>
  <div class="card-container" :class="{ 'shake-animation': isShaking }">
    <div class="title">
      <div class="title-left" @click="toggleCollapse">
        <i
          class="QS-icon-caret-right collapse-icon"
          :class="{ 'is-collapse': !isCollapse }"
        ></i>
        <span>{{ title }}</span>
      </div>
      <slot name="custom-header" v-if="isCollapse"></slot>
    </div>
    <div class="content" v-show="isCollapse">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  title: {
    type: String,
    required: true,
    default: '',
  },
})

const isCollapse = ref(true)
const isShaking = ref(false)

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
}

// 添加抖动方法
const shake = () => {
  isShaking.value = true
  setTimeout(() => {
    isShaking.value = false
  }, 500) // 动画持续时间
}

// 暴露方法给父组件使用
defineExpose({
  shake,
})
</script>

<style scoped lang="scss">
@import '@/styles/transition.scss';

.card-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;

  .title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    color: rgba(0, 0, 0, 0.9);
    align-items: center;

    .title-left {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      .collapse-icon {
        font-size: 10px;
        color: rgba(0, 0, 0, 0.4);
        transition: transform 0.3s;
        transform: rotate(90deg);

        &.is-collapse {
          transform: rotate(0deg);
        }
      }
    }
  }

  .content {
    padding-top: 16px;
    overflow: hidden;
  }
}
</style>
